/* Botanical Desire — Warenkorb-Helfer zu Venues cart-store (ohne eigenen Abruf).
   1 · Kopf-Zähler erst ab dem ersten Artikel (27.09.2026, Warenkorb A, C102).
   Setzt data-count an jede .cart-count-bubble (Kopfzeile mobil und Desktop); die Regel
   .cart-count-bubble[data-count="0"]{display:none} steht in bd-venue-skin.css (Block
   „NAVIGATION — WARENKORB-ZAEHLER“). Die Zahl selbst schreibt weiter Venues cart-link.js —
   dieses Modul liest nur denselben Stand aus Venues cart-store, ohne eigenen Abruf.
   Den Startwert vor dem Modul hält snippets/cart-templates.liquid (nur bei leerem Warenkorb).
   Keine Animation: der Zähler erscheint beim ersten Artikel einfach.
   2 · Fokus nach „Entfernen“ (Live-Fehler 1.19, freigegeben Tobias 01.10.2026) — siehe unten. */
import Cart from "cart-store";

function setzen(anzahl) {
  const wert = String(Number(anzahl) || 0);
  document.querySelectorAll(".cart-count-bubble").forEach((el) => {
    if (el.getAttribute("data-count") !== wert) el.setAttribute("data-count", wert);
  });
}

function start() {
  try {
    const stand = Cart.getState().cart;
    setzen(stand ? stand.item_count : 0);
  } catch (e) {
    /* ohne Store bleibt der Zähler, wie Venue ihn rendert */
  }
  Cart.subscribe((state) => {
    if (state && state.cart) setzen(state.cart.item_count);
  });
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
else start();

/* 2 · Fokus nach „Entfernen“ (Schublade und /cart, alle Breiten).
   Venues cart-components.js nimmt die Zeile nach der Antwort des Warenkorbs aus dem DOM
   (CartItems) bzw. tauscht beim letzten Artikel den ganzen Inhalt gegen den Leerzustand
   (InteractiveCart) — der Fokus lag dann auf <body>, mit der Tastatur ging es von vorn los
   (gemessen 01.10.2026: 375 px, Schublade und /cart). Hier ohne Eingriff in Venues Datei:
   Beim Klick auf [cart-item-remove] (auch per Enter) merkt sich das Modul Liste und Platz der
   Zeile; ist sie fort und der Fokus verloren, geht er auf „Entfernen“ der Zeile, die jetzt an
   ihrem Platz steht (sonst der vorigen), bei leerem Warenkorb auf den Satz des Leerzustands
   („Dein Warenkorb ist leer“, dafür tabindex="-1"). Nur wenn der Fokus wirklich verloren ist —
   steht er schon woanders (Klick ins Fenster, Schließen), bleibt er dort. Keine eigene Ansage:
   der fokussierte Text wird vorgelesen; die Live-Region des Mengenrabatts (bd-cart-progress)
   meldet weiter nur ihren Stand. */
const FOKUS_SEL = "[cart-item-remove]";
let merk = null;

function fokusVerloren(m) {
  const a = document.activeElement;
  return !a || a === document.body || a === document.documentElement || !a.isConnected || m.zeile.contains(a);
}

function fokusSetzen(m) {
  if (!fokusVerloren(m)) return;
  let ziel = null;
  if (m.liste && m.liste.isConnected) {
    const zeilen = Array.from(m.liste.querySelectorAll("cart-item")).filter((z) => z.isConnected && z.getClientRects().length);
    if (zeilen.length) {
      const z = zeilen[Math.min(m.platz, zeilen.length - 1)];
      ziel = z.querySelector(FOKUS_SEL) || z.querySelector("quantity-input input, a[href]");
    }
  }
  if (!ziel) {
    const raum = m.korb && m.korb.isConnected ? m.korb : document;
    const sichtbar = (el) => el && el.getClientRects().length > 0;
    const titel = raum.querySelector("cart-empty .cart-empty__title");
    if (sichtbar(titel)) {
      if (!titel.hasAttribute("tabindex")) titel.setAttribute("tabindex", "-1");
      ziel = titel;
    } else {
      ziel = Array.from(raum.querySelectorAll("cart-empty a[href]")).find(sichtbar) || null;
    }
  }
  if (ziel) ziel.focus();
}

document.addEventListener(
  "click",
  (e) => {
    const knopf = e.target && e.target.closest ? e.target.closest(FOKUS_SEL) : null;
    if (!knopf) return;
    const zeile = knopf.closest("cart-item");
    if (!zeile) return;
    const liste = zeile.closest("cart-items") || zeile.parentElement;
    const korb = zeile.closest("interactive-cart");
    const platz = Array.from(liste.querySelectorAll("cart-item")).indexOf(zeile);
    if (merk && merk.beobachter) merk.beobachter.disconnect();
    const m = { zeile, liste, korb, platz: Math.max(platz, 0) };
    merk = m;
    /* Warten, bis Venue die Zeile entfernt hat (Antwort des Warenkorbs). Venue entfernt Zeile und
       baut den Leerzustand im selben Durchlauf — der Beobachter meldet sich danach (Mikrotask), der
       Fokus steht also, bevor ein Bild gemalt wird und bevor die Fokus-Rettung der Desktop-Schicht
       (bd-desktop.js, Schublade §3, setTimeout) greift. Ohne Erfolg nach 15 s (Fehler) aufgeben. */
    const pruefen = () => {
      if (merk !== m || m.zeile.isConnected) return;
      m.beobachter.disconnect();
      clearTimeout(m.uhr);
      merk = null;
      fokusSetzen(m);
    };
    m.beobachter = new MutationObserver(pruefen);
    m.beobachter.observe(korb || liste.parentElement || document.body, { childList: true, subtree: true });
    m.uhr = setTimeout(() => { if (merk === m) { m.beobachter.disconnect(); merk = null; } }, 15000);
  },
  true
);
